import { render, staticRenderFns } from "./Salas.vue?vue&type=template&id=063ef7d4&scoped=true"
import script from "./Salas.vue?vue&type=script&lang=js"
export * from "./Salas.vue?vue&type=script&lang=js"
import style0 from "./Salas.vue?vue&type=style&index=0&id=063ef7d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063ef7d4",
  null
  
)

export default component.exports